// 跳转订阅
export const gotoPlans = () => {
    window.location.href = `//${window.location.host}/#plans`;
  };